/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';

/**
 *
 * @export
 * @interface AutosavePalAuthSubmissionRequest
 */
export interface AutosavePalAuthSubmissionRequest {
    /**
     *
     * @type {string}
     * @memberof AutosavePalAuthSubmissionRequest
     */
    form_id: string;
    /**
     *
     * @type {string}
     * @memberof AutosavePalAuthSubmissionRequest
     */
    expected_saved_at?: string | null;
    /**
     *
     * @type {{ [key: string]: any; }}
     * @memberof AutosavePalAuthSubmissionRequest
     */
    values: { [key: string]: any; };
}

/**
 * Check if a given object implements the AutosavePalAuthSubmissionRequest interface.
 */
export function instanceOfAutosavePalAuthSubmissionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "form_id" in value;
    isInstance = isInstance && "values" in value;

    return isInstance;
}

export function AutosavePalAuthSubmissionRequestFromJSON(json: any): AutosavePalAuthSubmissionRequest {
    return AutosavePalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function AutosavePalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutosavePalAuthSubmissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'form_id': json['form_id'],
        'expected_saved_at': !exists(json, 'expected_saved_at') ? undefined : json['expected_saved_at'],
        'values': json['values'],
    };
}

export function AutosavePalAuthSubmissionRequestToJSON(value?: AutosavePalAuthSubmissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'form_id': value.form_id,
        'expected_saved_at': value.expected_saved_at,
        'values': value.values,
    };
}

